export default __webpack_public_path__ + "static/media/eixoOco.186b3245.png";